import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import Modal from 'LuxKit/Modal/Modal'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import AmenityItem from './AmenityItem'
import type { DrawerHotelAmenity } from './types'

const AmenitiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: ${rem(8)};
  grid-column-gap: ${rem(16)};
  overflow: hidden;
`

const VISIBLE_AMENITIES_COUNT = 8

interface Props {
  amenities: Array<DrawerHotelAmenity>
}

function HotelDetailAmenities({ amenities }: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const visibleAmenities = amenities.slice(0, VISIBLE_AMENITIES_COUNT)
  const hiddenCount = Math.max(0, amenities.length - VISIBLE_AMENITIES_COUNT)

  const amenitiesTitle = intl.formatMessage({
    id: 'jyePaLajQlRWluKoM0Sv',
    defaultMessage: 'Amenities',
    description: 'Heading for hotel amenities section on the hotel or room booking page',
  })

  const handleViewAll = useCallback(() => {
    showModal(
      <Modal title={amenitiesTitle}>
        <AmenitiesGrid>
          {amenities.map((amenity) => (
            <AmenityItem key={amenity.name} amenity={amenity} />
          ))}
        </AmenitiesGrid>
      </Modal>,
    )
  }, [amenities, amenitiesTitle, showModal])

  return (
    <Group direction="vertical" gap={20}>
      <Heading variant="heading5">{amenitiesTitle}</Heading>
      <AmenitiesGrid>
        {visibleAmenities.map((amenity) => (
          <AmenityItem key={amenity.name} amenity={amenity} />
        ))}
      </AmenitiesGrid>
      {hiddenCount > 0 && (
        <div>
          <TextButton kind="secondary" onClick={handleViewAll}>
            {intl.formatMessage(
              {
                id: 'WEiPhVRdw0bSuv0HcFKv',
                defaultMessage: 'View all {count} amenities',
                description: 'Action button to view all hotel amenities in a modal',
              },
              { count: amenities.length },
            )}
          </TextButton>
        </div>
      )}
    </Group>
  )
}

export default HotelDetailAmenities
